// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"11c7cd10abbb22f1","7853":"b5429893e4eb7820"}[chunkId] + ".css";
};